import script from "./MoreInfoPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoreInfoPanel.vue?vue&type=script&setup=true&lang=ts"

import "./MoreInfoPanel.vue?vue&type=style&index=0&id=701aa82a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-701aa82a"]])

export default __exports__